import ProductTag from '@nespresso/catalog-components-react/controls/ProductTag';
import { Tag } from '@nespresso-design-system/components';
import styles from './ProductTagsSection.module.scss';
import type { Product } from '@/domain/Product.ts';
import useTranslations from '@/widgets/hooks/useTranslations';

type ProductTagsSectionProps = {
  product: Product;
};

function ProductTagsSection({ product }: ProductTagsSectionProps) {
  const { t } = useTranslations();
  const outOfStockTranslation = t(
    'productList.productTagsSection.outOfStockLabel'
  );

  const { highlightLabels = [] } = product;

  return (
    <header class={styles.tags}>
      {!product.inStock && outOfStockTranslation ? (
        <Tag label={outOfStockTranslation} variant="informative" />
      ) : (
        highlightLabels.map((highlightLabel) => (
          <ProductTag
            name={highlightLabel.label}
            key={highlightLabel.id}
            bgColor={highlightLabel.bgColor}
            color={highlightLabel.fgColor}
          />
        ))
      )}
    </header>
  );
}

export default ProductTagsSection;
